import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 1rem;
  position: relative;

  input[type="password"] {
    padding-right: 3.5rem;
  }

  input {
    padding: 0.5rem;
    border: 1px;
    border-radius: 0.25rem;
    font-size: 1rem;
    background-color: #ebebeb;
  }

  .password-toggle {
    position: absolute;
    top: 50%;
    right: 0.5rem;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    cursor: pointer;
  }
`;
